import { AxiosPromise } from "axios";
import { apiInstance } from "shared/api";
import {
  CodeBody,
  ConfirmCodeResponse,
  LoginBody,
  LoginResponse,
  LogoutResponse,
} from "./types";

export const login = (params: LoginBody): AxiosPromise<LoginResponse> => {
  return apiInstance.post("/v1/auth/login", params);
};

export const confirmCode = (
  params: CodeBody,
): AxiosPromise<ConfirmCodeResponse> => {
  return apiInstance.post("/v1/auth/check", params);
};

export const logout = (): AxiosPromise<LogoutResponse> => {
  return apiInstance.post("/v1/auth/logout");
};
